export let homeList = [
    {
        id: 'new001',
        type: 'phones',
        homeImg: require("../assets/images/prodoct/2.jpg"),
        obj1: {
            title: 'New Arrival Samsung Galaxy A06 64GB+4GB 50MP Camera 6.7" 90Hz MTK Helio G85 (12nm) 5000mAh 25W Type-C Charge Android 14 Smart Phones Side Fingerprint Unlock',
            money: '414524',
            color: ['Black','Light Blue'],
            storage: ['64GB+4GB'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Samsung' },
                { label: 'Model', value: 'A06 4+64G' },
                { label: 'Condition', value: 'Brand New' },
                { label: 'Screen Size', value: '6.7 inch' },
                { label: 'Screen Material', value: 'LCD' },
                { label: 'RAM', value: '4GB' },
                { label: 'ROM', value: '64GB' },
                { label: 'Battery Capacity', value: '5000mAh' },
                { label: 'Battery Type', value: 'Non-Detachable' },
                { label: 'Warranty', value: '24 Months' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/7451/2024/01/17050529415810fb2b16809cd40e891582ca61264c42e.png',
                'https://image.kilimall.com/kenya/shop/store/goods/7451/2024/01/17050529418478023b40211ed4d0ab969cee0dda9c43c.png'
            ]
        },
    },
    {
        id: 'new002',
        type: 'phones',
        homeImg: require("../assets/images/prodoct/3.jpg"),
        obj1: {
            title: 'Tempered Glass Camera Lens Ring Protector for iPhone 14',
            money: '10647',
            color: ['Black','red','Gold'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Material', value: 'Glass' },
                { label: 'Warranty', value: '6 months' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/9159/goods/image/101883881.jpg',
                'https://img.kilimall.com/c/public/store/9159/goods/image/101883882.jpg',
                'https://img.kilimall.com/c/public/store/9159/goods/image/101883883.jpg'
            ]
        },
    },
    {
        id: 'sale001',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/2.jpg"),
        obj1: {
            title: 'Nunix 138L BCD-138 fridge double door Direct Cool fridge Refrigerator fridges and freezers',
            money: '820559',
            color: ['Silver'],
            Size: ['138L'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Nunix' },
                { label: 'Freezer Capacity', value: '/' },
                { label: 'Warranty', value: '12 Months' },
                { label: 'Capacity(L)', value: '138L' },
                { label: 'Number of Doors', value: '2' },
                { label: 'Material', value: '/' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/7711/2023/07/16897543839652e849490e448476eadfb17ae8cab9920.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7711/2023/07/168975442358937fd542556b64259a1596fc8d23bc239.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7711/2023/07/1688633600497add51fca84364d77b1e5db2f946c1595.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },

    {
        id: 'sale00',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/8.jpg"),
        obj1: {
            title: 'Hisense 7.5 kg WSQB753W Twin-tub Washing Machine',
            money: '618961',
            color: ['White'],
            Size: ['7.5 kg'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Hisense' },
                { label: 'Type', value: 'Washers' },
                { label: 'Warranty', value: '24 Months' },
                { label: 'Weight(Kg)', value: '19KG' },
                { label: 'Washer Capacity(KG)', value: '7.5KG' },
                { label: 'Material', value: '/' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/5822/2022/06/16545722438440547a8d8bb7d40958e5bee997f661d09.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5822/2022/06/16545902193173f95259467a24e57ab6e76553339e906.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5822/2022/05/16539803768475aff084c2dd74814a95cadddb2a002b9.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale0012', type: 'Shoes',
        homeImg: require("../assets/images/flash/12.jpg"),
        obj1: {
            title: "SXCHEN Women's Shoes Boots Over-The-Knee Ladies Shoes Long Boots Women Boots New Edition Boots Show Slim Knee High Elastic Suede Boots for Women Boots For Girl Party Gift Style Boots In Black Fashion",
            money: '966647',
            color: ['Black'],
            size: [37,38,39,40],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Generic' },
                { label: 'Heel Style', value: 'Fashion' },
                { label: 'Shoes Department', value: 'Women' },
                { label: 'Heel Height', value: 'Low (2.5-4.9 cm)' },
                { label: 'Shoes Upper Material', value: 'PVC' },
                { label: 'Shoes Toe Shape', value: 'Round Toe' },
                { label: 'Shoes Closure', value: 'Pull On' },
                { label: 'Warranty', value: '7 Days' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/4805/2023/06/168629748057058c60080c51c4d2a9f1d06f725e2dd68.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/4805/2022/12/4805_07242550273732066.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/4805/2022/12/4805_07242550276034546.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale0013', type: 'Shoes',
        homeImg: require("../assets/images/flash/13.jpg"),
        obj1: {
            title: "SXCHEN New Men's Shoes Slippers Cool Men Cork Flip Non-Slip Beach Sandals Slippers Dad Casual Air Force Fashion Boy's Inside and Outside Birthday Household Shoes Durable Shoe Slippers",
            money: '31205',
            color: ['Black'],
            size: [38,39,40],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Generic' },
                { label: 'Style', value: 'Fashion' },
                { label: 'Shoes Department', value: 'Men' },
                { label: 'Heel Height', value: 'Flat(Under 2.5 cm)' },
                { label: 'Heel Style', value: 'Flat' },
                { label: 'Shoes Upper Material', value: 'PU' },
                { label: 'Shoes Toe Shape', value: 'Open Toe' },
                { label: 'Warranty', value: '7 Days' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/6151/2024/01/17048526986802f6b1a67fef74b8e9ded756e35145dfb.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/6151/2023/11/1700647065770f6a06c5a6d5e4097b4a901cccf72def8.png?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/6151/2023/11/170064706583922903614d89b496d97c0fadbc938effb.png?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'bags002', type: 'Bags',
        homeImg: require("../assets/images/home/home2.jpg"),
        obj1: {
            title: "4pcs/set Fashion multi-piece women's bag handbags bill shoulder crossbody bag",
            money: '25526',
            color: ['Black','Pink','White'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Size', value: 'Large' },
                { label: 'Material', value: 'PU' },
                { label: 'Closure Type', value: 'Zipper' },
                { label: 'Shape', value: 'Tote' },
                { label: 'Pattern', value: 'Solid' },
                { label: 'Warranty', value: '7 Days' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/5859/goods/image/100967389.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/5859/goods/image/100967390.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/5859/goods/image/101357919.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'bags003', type: 'Bags',
        homeImg: require("../assets/images/home/home3.jpg"),
        obj1: {
            title: "4 Sets/PCS Bags Handbags For Ladies Women Bags Lady Bags Purse Clutch Shoulder Bags Lady Purse Wallet",
            money: '683671',
            color: ['Black','Pink','White'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Generic' },
                { label: 'Size', value: 'Medium' },
                { label: 'Material', value: 'PU' },
                { label: 'Closure Type', value: 'Zipper' },
                { label: 'Shape', value: 'Boston' },
                { label: 'Style', value: 'Fashionable' },
                { label: 'Pattern', value: 'Solid' },
                { label: 'Warranty', value: '1 Month' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/6549/2023/09/6549_07473564427136479.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/6549/2023/09/6549_07473564426906056.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/6549/goods/image/102152524.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale002',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/3.jpg"),
        obj1: {
            title: 'Hisense 94 Liters fridge single door Energy Saving REFO94DR Refrigerator',
            money: '823399',
            color: ['White'],
            Size: ['as picture'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'RAMTONS' },
                { label: 'Number of Modes', value: '6' },
                { label: 'Warranty', value: '12 Months' },
                { label: 'Capacity(L)', value: '128L' },
                { label: 'Number of Doors', value: '1' },
                { label: 'Material', value: 'Aluminium' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/5822/2022/06/16558694599736d24b504e21d45abb6af4f27df3b74ba.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5822/2022/05/16538818814659f02931923434f7aa69da73f6800d139.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5822/2022/05/165364709569583395c12310e44b6b9626587b80af2f7.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale007',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/1.jpg"),
        obj1: {
            title: 'Hisense 8KG WTJA802T Automatic Washing Machine Wash and Spin Washers',
            money: '522422',
            color: ['Titanium crystal grey'],
            Size: ['8kg'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Hisense' },
                { label: 'Model', value: 'WTJA802T' },
                { label: 'Warranty', value: '24 Months' },
                { label: 'Washing Capacity (Kg)', value: '8KG' },
                { label: 'Condition', value: 'Brand New' },
                { label: 'Material', value: '/' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/7940/2022/07/165779055257468543a761e784a53ab9e1f8bb0cb0d3a.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7940/2022/07/1657790552883e7636ac899ef424786d26932cded19fd.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7940/2022/07/16577905527312e8fbfd4b08b458ebf9d51a4d78f2353.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new003',
        type: 'phones',
        homeImg: require("../assets/images/prodoct/4.jpg"),
        obj1: {
            title: 'Infinix HOT 40i,5000mah,8GB(4GB RAM+4GB RAM)128GB ROM,50MP,TYPE-C,+BUDS And WATCH',
            money: '383291',
            color: ['Black','Gold'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Cpu Brand', value: 'Unisoc' },
                { label: 'Cpu Model', value: 'Unisoc T606 (12 nm)' },
                { label: 'Condition', value: 'Brand New' },
                { label: 'Screen Size', value: '6.6 inch Display' },
                { label: 'Screen Material', value: 'LCD' },
                { label: 'RAM', value: '4GB' },
                { label: 'ROM', value: '128GB' },
                { label: 'Battery Capacity', value: '5000mAh' },
                { label: 'NFC/NFC Models', value: 'yes' },
                { label: 'Warranty', value: '6 Months' },
            ],
            imgs:[]
        },
    },
    {
        id: 'new004',
        type: 'phones',
        homeImg: require("../assets/images/prodoct/5.jpg"),
        obj1: {
            title: 'Refurbished Samsung Galaxy S10 4G Smartphones 128GB+8GB 6.1 "AMOLED Display 12MP+10MP Rear Triple Camera 3400mAh Type-C Fast Charging Dual SIM Fingerprint Unlock Mobile Phones',
            money: '701304',
            color: ['Random Color'],
            storage: ['8GB+128GB'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Condition', value: 'Brand New' },
                { label: 'Screen Material', value: 'LCD' },
                { label: 'Cpu Brand', value: 'Unisoc' },
                { label: 'Cpu Model', value: 'Unisoc T606 (12 nm)' },
                { label: 'Screen Size', value: '6.6 inch Display' },
                { label: 'RAM', value: '4GB' },
                { label: 'ROM', value: '128GB' },
                { label: 'Battery Capacity', value: '5000mAh' },
                { label: 'NFC/NFC Models', value: 'yes' },
                { label: 'Warranty', value: '12 Months' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/8722/goods/image/102073534.jpg?x-image-process=image/format,webp/resize,w_720#g',
                'https://img.kilimall.com/c/public/store/8722/goods/image/102073540.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/8722/goods/image/102073537.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new005', type: 'phones',
        homeImg: require("../assets/images/prodoct/6.jpg"),
        obj1: {
            title: 'Xiaomi Redmi 13C 6.74" 4GB RAM + 128GB Storage 4G Network Dual SIM 90Hz LCD Screen 50MP Camera 18W Type-C Charging 5000mAh Battery Fingerprin t& Face Smart Phones Phone',
            money: '372813',
            color: ['Navy Blue','Midnight Black','Clover Green'],
            storage: ['128GB'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Condition', value: 'Brand New' },
                { label: 'Brand', value: 'XIAOMI' },
                { label: 'Model', value: '13C' },
                { label: 'Screen Material', value: 'IPS' },
                { label: 'Screen Size', value: '6.7 inch' },
                { label: 'RAM', value: '4GB' },
                { label: 'ROM', value: '128GB' },
                { label: 'Battery Capacity', value: '5000mAh' },
                { label: 'Cpu Model', value: 'Helio' },
                { label: 'Warranty', value: '24 Months' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/8299/goods/image/101263466.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/8299/goods/image/101263468.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/8299/goods/image/101263469.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new006', type: 'phones',
        homeImg: require("../assets/images/prodoct/7.jpg"),
        obj1: {
            title: 'Dual speaker smart earphone Wired Earphones Super Bass 3.5mm headphones Hands Free Earbuds with Mic',
            money: '8489',
            color: ['Black','White'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Condition', value: 'Brand New' },
                { label: 'Brand', value: 'Generic' },
                { label: 'Connection Type', value: 'Wired' },
                { label: 'Support Bluetooth', value: 'No' },
                { label: 'Control Button', value: 'Yes' },
                { label: 'Volume Control', value: 'Yes' },
                { label: 'Waterproof Degree', value: 'IPX6' },
                { label: 'Audio Port', value: '3.5mm' },
                { label: 'Warranty', value: '12 Months' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/5578/2021/12/1638986664130c8ff1ee2afd34d2f8f5d9e3f9b9d2da8.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5578/2021/12/16389866725034cac08c2a1a24c8eae9592c290422f43.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5578/2021/12/1638986663855fb3e544074a64c6d922b8fe5143e0f4a.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new007', type: 'phones',
        homeImg: require("../assets/images/prodoct/8.jpg"),
        obj1: {
            title: 'Brand New Itel IEP-25 Wired Eaephone wired earphone type: in-ear driver size: 10mm microphone: yes compatibility: all 3.5mm jack devices other: in-ear headphones',
            money: '6984',
            color: ['Black'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Connection Type', value: 'Wired' },
                { label: 'Brand', value: 'Itel IEP-25 Wired' },
                { label: 'Control Button', value: 'Yes' },
                { label: 'Noise Canceling', value: 'Yes' },
                { label: 'Support Bluetooth', value: 'No' },
                { label: 'Volume Control', value: '4GB' },
                { label: 'ROM', value: 'Yes' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/100002063/goods/image/101359166.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/100002063/goods/image/101359167.jpg?x-image-process=image/format,webp/resize,w_720#https://img.kilimall.com/c/public/store/8299/goods/image/101263468.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/100002063/goods/image/101359169.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new008', type: 'phones',
        homeImg: require("../assets/images/prodoct/9.jpg"),
        obj1: {
            title: 'Handheld Grip Stabilizer Phone Tripod Holder Selfie Stick Handle Holder Stand Live Broadcast Bracket live video',
            money: '22686',
            color: ['Black'],
            quantity: 1
        },
        obj2: {
            details: [],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/2090/2021/11/16359238372015efd4a5593bf47468ecc85f7d913be67.jpeg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/2090/2021/11/2090_06892671188890677.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/2090/2021/11/2090_06892671191473314.png?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new009', type: 'phones',
        homeImg: require("../assets/images/prodoct/10.jpg"),
        obj1: {
            title: '3-Axis Gimbal Stabilizer for Smartphone Foldable Handheld Phone Video Record Vlog Anti-Shake Stabilizer PTZ for iPhone Android',
            money: '316877',
            color: ['Black'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Compatible Devices', value: 'Smart Devices' },
                { label: 'With Ring light', value: 'No' },
                { label: 'Material', value: 'Alloy' },
                { label: 'Support Bluetooth', value: 'Yes' },
                { label: 'Warranty', value: '1 Month' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/100002432/goods/image/102093599.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/100002432/goods/image/102093600.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/100002432/goods/image/102093601.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new0010', type: 'phones',
        homeImg: require("../assets/images/prodoct/11.jpg"),
        obj1: {
            title: 'Micro USB Data Cables Fast Charging data line For Android Phone Nylon charging cables Charger Cable',
            money: '3378',
            color: ['Black','silver'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Line length', value: '1m' },
                { label: 'Type', value: 'USB 2.0 Charging&Data Sync Cable' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/5578/2020/07/5578_06484226626905858_720.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5578/2020/07/5578_06484226633332443_720.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5578/2020/07/5578_06484226632521893_720.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new0011', type: 'phones',
        homeImg: require("../assets/images/prodoct/12.jpg"),
        obj1: {
            title: 'Upgrade Extra Thick 120W 6A (Extemely Fast) Charging Cable Type C,iPhone,Micro USB,High Speed Data Sync USB Cable For most phone(iphone,Samsung,tecno,xiaomi,oppo,infinix,etc.)',
            money: '6786',
            color: ['White'],
            Model: ['type c', 'Iphone','micro usb'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Generic' },
                { label: 'Length (M)', value: '1.2' },
                { label: 'Compatible Devices', value: 'Smartphone' },
                { label: 'Cable Type', value: 'USB' },
                { label: 'Warranty', value: '12 Month' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/9751/2023/05/1685427293054cc107a5ce7f041029b50cf9bb4b16d45.png?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/9751/2023/05/1684827783557298beaf478814607b6051e9c85d18dd1.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/9751/2023/05/16842277150042592bb4a066e4ba695beb6aad5dc9fdd.jpeg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },





    {
        id: 'bags001', type: 'Bags',
        homeImg: require("../assets/images/home/home1.jpg"),
        obj1: {
            title: "4 Sets/PCS Bags Handbags For Ladies Women Bags Lady Bags Purse Clutch Shoulder Bags Lady Purse Wallet",
            money: '683671',
            color: ['Black','Pink','White'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Generic' },
                { label: 'Size', value: 'Medium' },
                { label: 'Material', value: 'Faux Leather' },
                { label: 'Closure Type', value: 'Zipper' },
                { label: 'Shape', value: 'Hobo' },
                { label: 'Pattern', value: 'Geometric' },
                { label: 'Warranty', value: '7 Days' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/5824/2023/05/16855239737012ee0a71a971e4d39b29c6d006d24521f.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5824/2021/11/16370486911656dd8ae1eba7e435fa54f6322660f93fe.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5824/2021/11/1637050985989d327dcc40cd242a5972e5d538d3edbc9.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'new0012', type: 'Shoes',
        homeImg: require("../assets/images/prodoct/1.jpg"),
        obj1: {
            title: 'SXCHEN New Men’s Shoes Martin Boots Trendy Shoes High-top Tooling Boots Wild Trend Plus Boy Fashion Sneakers Basketball Shoes Run Sports Mountaineering Casual Outdoor Trave Men&apos;s Shoes Air Force',
            money: '48241',
            color: ['White'],
            size: [44,43,42,41],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Style', value: 'Fashion' },
                { label: 'Brand', value: 'Generic' },
                { label: 'Department', value: 'Men' },
                { label: 'Heel Height', value: 'Low (2.5-4.9 cm)' },
                { label: 'Heel Style', value: 'Flat' },
                { label: 'Warranty', value: '15 Days' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/6151/2024/01/6151_07588950377847491.png?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/6151/2023/10/169873740156337e58fd48cce4ee78a43d8a94d504ad0.jpeg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/6151/2021/07/6151_06791432006443501_720.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },





    {
        id: 'sale003',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/4.jpg"),
        obj1: {
            title: '【Discounted】Ramtons RF/174 - 128 Liters 2 Door Direct Cool Fridge - 128 Liters Refrigerators Fridge Freezer Energy Saving Double Doors Home Improvement 【HOT】',
            money: '678589',
            color: ['Silver'],
            Size: ['148L'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Nunix' },
                { label: 'Number of Modes', value: '/' },
                { label: 'Warranty', value: '12 Months' },
                { label: 'Capacity(L)', value: '148L' },
                { label: 'Number of Doors', value: '2' },
                { label: 'Material', value: '/' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/5310/2022/10/16652085791992ce90231cc4e4c3389b145d8c7955698.jpeg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5310/2023/08/169200893006279496ee93d364f809f609cd1a6b7e92f.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/5310/2023/08/169200893535597b9fb9dd5044ba282f066b8834e841f.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale004',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/5.jpg"),
        obj1: {
            title: 'Nunix 138L BCD-138 fridge double door Direct Cool fridge Refrigerator fridges and freezers',
            money: '610443',
            color: ['Silver'],
            Size: ['108L'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Volsmart' },
                { label: 'Number of Modes', value: '7' },
                { label: 'Warranty', value: '12 Months' },
                { label: 'Capacity(L)', value: '108L' },
                { label: 'Number of Doors', value: '2' },
                { label: 'Material', value: 'Steel' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/10874/goods/image/101296567.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/10874/goods/image/101296568.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/10874/goods/image/101296576.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale005',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/6.jpg"),
        obj1: {
            title: 'Haier HRD-1954CSS -190L Single Door Fridge',
            money: '1041948',
            color: ['Gray'],
            Size: ['190L'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'HAIER' },
                { label: 'Number of Modes', value: '1' },
                { label: 'Warranty', value: '24 Months' },
                { label: 'Capacity(L)', value: '190L' },
                { label: 'Number of Doors', value: '1' },
                { label: 'Material', value: 'Glass' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/11338/2024/01/17050618363107629c852e6f5473390e2d07b3703235f.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/11338/2024/01/1705064379424bdb752e7904342fc9b6a1fa0bd5df797.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/11338/2024/01/17054701460195c0c1e0180834c5bbf0fc0c2f53404f5.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale006',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/7.jpg"),
        obj1: {
            title: 'Vitron 90L Single Door Refrigerator VDR9OSS/VDR9OSG Enerygy Saving Fridge',
            money: '522422',
            color: ['Silver','Gray'],
            Size: ['90L'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'VITRON' },
                { label: 'Number of Modes', value: '5' },
                { label: 'Warranty', value: '12 Months' },
                { label: 'Capacity(L)', value: '90L' },
                { label: 'Number of Doors', value: '1' },
                { label: 'Material', value: 'PCM' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/7593/goods/image/102111290.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/7593/goods/image/102111321.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/7593/goods/image/102111292.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    
    {
        id: 'sale009',
        type: 'Appliances',
        homeImg: require("../assets/images/flash/9.jpg"),
        obj1: {
            title: 'Hisense 9KG Front Load Washing Machine 1400RMP washing machine automatic',
            money: '55399',
            color: ['Grey'],
            Size: ['9 kg'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Hisense' },
                { label: 'Type', value: 'All-In-One Combination Washers & Dryers' },
                { label: 'Warranty', value: '24 Months' },
                { label: 'Item Dimensions(LxWxH cm)', value: '66cm*58cm*89cm' },
                { label: 'Condition', value: 'Brand New' },
                { label: 'Material', value: '/' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/7940/2022/07/1657869622844d32fe120d34d4e1c8bfe5d26d560cd74.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7940/2023/08/16911276802642c2b4992194147d2b13d95432d9460ca.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7940/2022/07/16578695957042aa5983bd89e44db88c22eab9f81bd3b.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale0010', type: 'Shoes',
        homeImg: require("../assets/images/flash/10.jpg"),
        obj1: {
            title: "Women's board shoes sports shoes girls athletic casual shoes classic ladies running shoes artificial leather PU leather white shoes students rose embroidery",
            money: '31205',
            color: ['White'],
            size: [38,39,40],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Generic' },
                { label: 'Shoes Department', value: 'Women' },
                { label: 'Heel Height', value: 'Flat(Under 2.5 cm)' },
                { label: 'Heel Style', value: 'Flat' },
                { label: 'Shoes Upper Material', value: 'Artificial Leather' },
                { label: 'Shoes Toe Shape', value: 'Round Toe' },
                { label: 'Shoes Closure', value: 'Lace Up' },
                { label: 'Warranty', value: '7 Days' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/4805/2023/06/168629748057058c60080c51c4d2a9f1d06f725e2dd68.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/4805/2022/12/4805_07242550273732066.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/4805/2022/12/4805_07242550276034546.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    {
        id: 'sale0011', type: 'Shoes',
        homeImg: require("../assets/images/flash/11.jpg"),
        obj1: {
            title: "Kids shoes Lightweight non-slip Children for Children and Pupils inSummer Mesh Breathable Sneakers boys Sneakers",
            money: '36883',
            color: ['Blue'],
            size: [30,31,32,33],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Brand', value: 'Generic' },
                { label: 'Kids Shoes Style', value: 'sports shoes' },
                { label: 'Kids Shoes Department', value: 'Boys' },
                { label: 'Shoes Upper Material', value: 'Synthetic Leather' },
                { label: 'Shoes Closure', value: 'Velcro' },
                { label: 'Kids Shoes Heel Height', value: 'Flat(Under 2.5 cm)' },
                { label: 'Warranty', value: 'NO' },
            ],
            imgs: [
                'https://image.kilimall.com/kenya/shop/store/goods/7479/2022/03/1646390683087f5e5eeccc4e04011baecf782b928a8d6.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7479/2022/03/164639068293096328d41c73641759c96e5c9d8a09fee.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://image.kilimall.com/kenya/shop/store/goods/7479/2023/04/168148663320753be1ab3f23943278047a0558baca26a.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
    
    
    
    {
        id: 'bags004', type: 'Bags',
        homeImg: require("../assets/images/home/home4.jpg"),
        obj1: {
            title: "Fashion Classic Trendy Ladies 5-in-1 Handbags Set offers unparalleled elegance and versatility, making it an essential accessory collection for every stylish woman. Crafted from premium PU leather, th",
            money: '683671',
            color: ['Black','Blue','Brown','Orange'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Size', value: 'Large' },
                { label: 'Material', value: 'PU' },
                { label: 'Features', value: 'Multi-Functional' },
                { label: 'Closure Type', value: 'Zipper' },
                { label: 'Shape', value: 'as in picture' },
                { label: 'Style', value: 'Fashionable' },
                { label: 'Pattern', value: 'Geometric' },
                { label: 'Warranty', value: '7 Days' },
                { label: 'Occasion', value: 'Versatile' },
            ],
            imgs: []
        },
    },
    {
        id: 'bags005', type: 'Bags',
        homeImg: require("../assets/images/home/home5.jpg"),
        obj1: {
            title: "4 Sets/PCS Bags Handbags For Ladies Women Bags Lady Bags Purse Clutch Shoulder Bags Lady Purse Wallet",
            money: '25497',
            color: ['Black','Pink','White'],
            quantity: 1
        },
        obj2: {
            details: [
                { label: 'Closure Type', value: 'Zipper' },
                { label: 'Size', value: 'Medium' },
                { label: 'Material', value: 'PU' },
                { label: 'Closure Type', value: 'Zipper' },
                { label: 'Shape', value: 'Saddle' },
                { label: 'Pattern', value: 'Checkered' },
                { label: 'Warranty', value: 'No Warranty' },
                { label: 'Features', value: 'Multi-Functional' },
            ],
            imgs: [
                'https://img.kilimall.com/c/public/store/9952/goods/image/101947960.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/9952/goods/image/101947961.jpg?x-image-process=image/format,webp/resize,w_720#',
                'https://img.kilimall.com/c/public/store/9952/goods/image/101947962.jpg?x-image-process=image/format,webp/resize,w_720#'
            ]
        },
    },
]